
export default function Footer() {
  const openWhatsApp = () => {
    const message = encodeURIComponent('Olá! Gostaria de saber mais sobre os serviços da DataPrec para precatórios e RPV. Podem me ajudar?');
    window.open(`https://wa.me/5531981041870?text=${message}`, '_blank');
  };

  const openWebsite = () => {
    window.open('https://www.dataprec.com', '_blank');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/d4d6d97e1263ef61b1eee88f513b68c5/a61bd32ab34d72a043152d16b1cc30e2.jfif" 
                alt="DataPrec Logo" 
                className="h-12 w-auto"
              />
            </div>
            
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Tecnologia, automação e inteligência de dados para transformar a forma como escritórios de advocacia, 
              empresas e investidores acessam informações estratégicas sobre precatórios e RPV.
            </p>

            <div className="flex space-x-4">
              <button 
                onClick={openWhatsApp}
                className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center hover:bg-green-7   00 transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white"></i>
              </button>
              <button 
                onClick={openWebsite}
                className="w-10 h-10 bg-gradient-to-r from-blue-600 to-indigo-700 rounded-lg flex items-center justify-center hover:from-blue-700 hover:to-indigo-800 transition-all cursor-pointer"
              >
                <i className="ri-global-line text-white"></i>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Início
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('sobre')}
                  className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Sobre
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('servicos')}
                  className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contato')}
                  className="text-gray-300 hover:text-blue-400 transition-colors cursor-pointer"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contato</h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <i className="ri-mail-line text-blue-400"></i>
                <span className="text-gray-300">comercial@dataprec.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-whatsapp-line text-green-400"></i>
                <span className="text-gray-300">(31) 98104-1870</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-global-line text-blue-400"></i>
                <span className="text-gray-300">www.dataprec.com</span>
              </div>
              <div className="flex items-center space-x-3">
                <i className="ri-map-pin-line text-blue-400"></i>
                <span className="text-gray-300">Belo Horizonte, Brasil</span>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center gap-4">
              <p className="text-gray-400 text-sm">
                © 2025 DataPrec. Todos os direitos reservados.
              </p>
              <div className="flex gap-4 text-sm">
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Política de Privacidade
                </button>
                <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Termos de Uso
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}
